export const metadataMap: Record<string, { title: string; description: string }> = {
  "/authentication/login": {
    title: "Acesse a sua conta da Flash - Login",
    description:
      "Entre com seu CPF e senha na sua conta da Flash - software unificado de gestão de benefícios, pessoas e despesas com cartão corporativo.",
  },
  "/authentication/password-recovery": {
    title: "Recupere sua senha - Flash",
    description: `Esqueceu sua senha Flash? Sem problemas! Basta inserir seu CPF aqui e clicar em "Continuar" para recuperar sua senha!`,
  },
  "/authentication/resend-invite": {
    title: "Reenvie seu convite - Flash",
    description:
      "Solicite o reenvio do convite para acessar sua conta Flash e continuar usando a plataforma HROS.",
  },
  "*": {
    title: "Flash - HROS",
    description:
      "Bem-vindo à Flash - software unificado de gestão de benefícios, pessoas e despesas com cartão corporativo.",
  },
};
